import { useEffect, useState } from 'react';
import { Shield, Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SessionTimeoutCountdownProps {
  secondsLeft: number;
  onStayLoggedIn: () => void;
  portalName?: string;
}

export default function SessionTimeoutCountdown({ secondsLeft, onStayLoggedIn, portalName = 'Session' }: SessionTimeoutCountdownProps) {
  if (secondsLeft <= 0) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm animate-fade-in">
      <div className="bg-card border border-border/60 rounded-2xl shadow-2xl p-8 max-w-sm w-full mx-4 text-center space-y-5">
        <div className="flex items-center justify-center w-16 h-16 mx-auto rounded-full bg-destructive/10 border border-destructive/20">
          <Clock className="w-8 h-8 text-destructive animate-pulse" />
        </div>
        
        <div className="space-y-2">
          <h2 className="text-lg font-semibold text-foreground">Session Expiring</h2>
          <p className="text-sm text-muted-foreground">
            Your session will expire due to inactivity in
          </p>
        </div>

        <div className="text-5xl font-bold tabular-nums text-destructive">
          {secondsLeft}
          <span className="text-lg font-normal text-muted-foreground ml-1">s</span>
        </div>

        <Button onClick={onStayLoggedIn} className="w-full h-11 rounded-xl text-sm font-semibold">
          Stay Logged In
        </Button>

        <p className="text-[11px] text-muted-foreground/60">
          Move your mouse or press any key to stay active
        </p>
      </div>
    </div>
  );
}
